import { otherApiClient } from "./index";
export const fetchAccessToken = async (id)=>{
    const { data  } = await otherApiClient.market("/auth/kakao/accessToken", {
        params: {
            identificationId: id
        }
    });
    return data;
};
export const fetchAccountHint = async (req)=>{
    const { data  } = await otherApiClient.market.post("/auth/account-hint", req);
    return data;
};
